var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"donut-chart-container",staticStyle:{"height":"100%"}},[_c('svg',{ref:"mainSvg"})])}
var staticRenderFns = []

export { render, staticRenderFns }